<template>
  <div class="flex grow flex-col overflow-y-auto bg-base dark:bg-neutral-800">
    <div class="flex flex-col shrink-0 items-center justify-center lg:sticky top-0 bg-base dark:bg-neutral-800 pt-6">
      <RouterLink to="/">
        <img class="max-h-24 max-w-40 w-full" src="@/assets/nurtur_logo.svg" alt="Nurtur Admin Hub" />
      </RouterLink>
      <h1 class="text-white font-semibold uppercase tracking-widest">Admin Hub</h1>

      <NtScopeModal />
    </div>
    <nav class="flex flex-1 flex-col px-6 pb-6 pt-3">
      <ul role="list" class="flex flex-1 flex-col gap-y-7">
        <li>
          <ul role="list" class="-mx-2 space-y-1">
            <template v-for="navItem in navItems" :key="navItem.id">
              <NtNavigationSidebarItem :item="navItem" />

              <hr v-if="navItem.divide" class="border-white/20" />
            </template>

            <li class="mt-auto" v-if="sentryFeedbackEnabled">
              <hr class="border-white/20 mb-1" />
              <ul role="list" class="space-y-1">
                <NtNavigationSidebarItem
                  :item="{
                    is_external: true,
                    id: 'sentryFeedback',
                    name: 'Send Feedback',
                    icon: 'fa-bullhorn',
                    is_published: true
                  }" />
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import NtNavigationSidebarItem from './NtNavigationSidebarItem.vue'
import { useSystemStore } from '@/stores/system'
import NtScopeModal from './NtScopeModal.vue'
import { useAuthStore } from '@/stores/auth'
import { canOpenPage } from '@/navigation'

export default {
  components: {
    NtNavigationSidebarItem,
    NtScopeModal
  },
  computed: {
    ...mapState(useSystemStore, ['routes']),
    ...mapState(useAuthStore, ['authUser']),
    sentryFeedbackEnabled() {
      return import.meta.env.VITE_SENTRY_FEEDBACK_ENABLED === 'true'
    },
    navItems() {
      return this.routes.filter(
        (r) => !r.parent_id && !r.modules.find((m) => m.model) && canOpenPage(r, this.routes, this.authUser)
      )
    }
  }
}
</script>
